<template>
    <div class="cumulative-wrapper">
        <div class="card-list">
            <CumulativeCard v-for="(item, index) in listData" :key="index" :data="item" />
        </div>
    </div>
</template>

<script>
import CumulativeCard from "./Card";

export default {
    name: "Cumulative",
    props: ["lang", "date", "title", "channel"],
    components: {
        CumulativeCard
    },
    data() {
        return {
            listData: []
        };
    },
    watch: {
        channel() {
            this.queryCumulativeData();
        },
        date() {
            this.queryCumulativeData();
        },
        lang() {
            this.queryCumulativeData();
        },
        title() {
            this.queryCumulativeData();
        }
    },
    methods: {
        queryCumulativeData() {
            this.zhiji
                .requestByServiceName("queryCumulativeData", {
                    date: this.date,
                    lang: this.lang,
                    channel: this.channel
                })
                .then(resp => {
                    this.listData = resp;
                });
        }
    },
    mounted() {
        this.queryCumulativeData();
    }
};
</script>

<style lang="scss" scoped>
.card-list {
    display: flex;
    margin-bottom: 24px;
}
</style>
